import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import useModal from 'hooks/useModal';
import { EventQuery } from 'queries';
import { IEvent } from 'types';

function useEventDelete(event: IEvent) {
  const navigate = useNavigate();
  const { handleConfirm } = useModal();
  const { mutateAsync: deleteEvent } = EventQuery.useDelete();

  const handleDelete = async () => {
    try {
      await deleteEvent(event.id);
      toast.success('행사가 삭제되었습니다.');
      navigate(-1);
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  const handleConfirmDelete = () =>
    handleConfirm({
      confirmContent: '삭제하시겠습니까?',
      yesTitle: '삭제',
      noTitle: '취소',
      confirmNext: handleDelete,
    });

  return { handleConfirmDelete };
}

export default useEventDelete;
